import Btn from '@components/Btn';
import { useRouter } from 'next/router';
import { useI18n } from '@lib/i18n';
import { useEffect } from 'react';
import { HP_ANIMATIONS, HP_ANIMATION_TYPE } from '@lib/constants';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function AdvisorButton() {
	const router = useRouter();
	const { t } = useI18n();

	const handleClick = () => {
		router.push('/advisor');
	};

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	return (
		<Btn
			onClick={handleClick}
			customClass={['outline', 'outline--home', 'advisor', `${animationClass}`]}
			{...animationData}
		>
			{t('home.advisor_mode', 'Advisor Mode')}
		</Btn>
	);
}
